"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _map = _interopRequireDefault(require("lodash/map"));

var _deepObjectDiff = require("deep-object-diff");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
} // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions


var Fragment = _react["default"].Fragment; // ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------

/** Notice */

var Notice = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Notice, _React$Component);
  /** [constructor description] */


  function Notice() {
    return _React$Component.call(this) || this;
  }

  var _proto = Notice.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var thatNoticeQueueState = prevProps.noticeQueueState;
    var thisNoticeQueueState = this.props.noticeQueueState;
    var diff = (0, _deepObjectDiff.diff)(thatNoticeQueueState, thisNoticeQueueState);
    var diffLength = Object.keys(diff).length; // Something changed

    if (diffLength !== 0) {
      // Find out what was added
      var added = (0, _deepObjectDiff.addedDiff)(thatNoticeQueueState, thisNoticeQueueState);
      var _this$props = this.props,
          notification = _this$props.notification,
          popNotice = _this$props.popNotice;
      (0, _map["default"])(added, function (item) {
        notification.open({
          className: 'notice mask-p',
          message: item.message,
          description: item.description,
          placement: 'bottomRight'
        });
        popNotice(item);
      });
    }
  }
  /** [render description] */
  ;

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(Fragment, null);
  };

  return Notice;
}(_react["default"].Component); // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = Notice;
exports["default"] = _default;
module.exports = exports.default;